import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-white/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1440px] mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 group flex-shrink-0">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className={`ri-fire-line text-2xl ${isScrolled || !isHome ? 'text-primary-500' : 'text-white'}`}></i>
          </div>
          <span className={`font-heading font-bold text-lg whitespace-nowrap ${
            isScrolled || !isHome ? 'text-foreground-950' : 'text-white'
          }`}>
            51在线吃瓜
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.slice(0, 6).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2 text-sm font-label rounded-lg transition-colors whitespace-nowrap ${
                isScrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className={`text-sm font-label whitespace-nowrap transition-colors ${
              isScrolled || !isHome ? 'text-foreground-600 hover:text-primary-500' : 'text-white/70 hover:text-white'
            }`}
          >
            关于我们
          </Link>
          <a
            href="#contribute"
            className="btn-primary text-xs px-4 py-2"
          >
            投稿爆料
          </a>
        </div>

        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center ${
            isScrolled || !isHome ? 'text-foreground-800' : 'text-white'
          }`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="打开菜单"
        >
          <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-background-200/70 animate-in">
          <div className="px-4 py-4 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-3 text-sm font-label text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <hr className="my-2 border-background-200/70" />
            <Link
              to="/about"
              className="px-3 py-3 text-sm font-label text-foreground-600 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors"
            >
              关于我们
            </Link>
            <a
              href="#contribute"
              className="mt-2 btn-primary text-center text-sm"
            >
              投稿爆料
            </a>
          </div>
        </div>
      )}
    </header>
  );
}